import React, {useState} from 'react';
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import Dropdown from 'react-bootstrap/Dropdown'
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import 'bootstrap/dist/css/bootstrap.min.css';
import logo from '../../resources/images/logo.svg'

const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
        Coming soon!
    </Tooltip>
);

const Layout = ({children, valueSetter}) => {
    const [value, setValue] = useState({

    });

    return(
        <>
            <Container>
                <Row className="mt-4">
                    <Col md="8" style={{borderBottom: "1px solid #000"}} className="align-content-sm-center">
                        <img src={logo} style={{width: '100%', maxWidth: 200 }} className="logo" alt="Logo Heeren Moeskops" />
                    </Col>
                    <Col md="4" className="text-end pt-3 d-none d-md-block" style={{borderBottom: "1px solid #000"}}>

                    </Col>
                </Row>
            </Container>
            {children}
        </>
    )
}

export default Layout;